/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.DocumentIssuesSummary = {
  _gridApi: null,

  _gridOptions: {
    paginationPageSize: 10,
    headerHeight: 44,
    rowHeight: 44,
    defaultColDef: {
      resizable: true
    }
  },

  _renderIssueSeverity(params) {
    return `<div class='issue-severity ${params.data.severity}'>${params.data.severity}</div>`;
  },

  initializeGrid(tableSelector, params) {
    $(document).foundation().on('opened.fndtn.reveal', '#submitModal[data-reveal]', () => DocumentIssuesSummary._gridApi.sizeColumnsToFit());

    const data = _.map(params, doc => JSON.parse(doc));

    const columnDefs = [
      {
        headerName: '',
        field: 'severity',
        cellRenderer: data => this._renderIssueSeverity(data)
      },
      {
        headerName: I18n.t('v4.document_sets.document_issues_summary.fixed'),
        field: 'fixed'
      },
      {
        headerName: I18n.t('v4.document_sets.document_issues_summary.not_fixed'),
        field: 'not_fixed'
      },
      {
        headerName: I18n.t('v4.document_sets.document_issues_summary.invalid'),
        field: 'invalid'
      }
    ];

    this._gridOptions.columnDefs = columnDefs;
    this._gridOptions.rowData = data;

    const gridDiv = document.getElementById(tableSelector);
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    return resizeAgGridTable(`#${tableSelector}`, this._gridOptions);
  }
};
